import React from 'react'

import Grid from '@material-ui/core/Grid'
import EurestoDiv from 'EurestoComponents/EurestoDiv/index'
import User from 'EurestoClass/User'
import Data from 'EurestoClass/Data'
import Constants from 'EurestoFonction/Constants'
import Input from 'Components/Input'
import moment from 'moment'
import project from 'EurestoConfig/project.config'
import ApiRequest from 'EurestoApi/ApiRequest'
import InfinityScroll from 'Components/InfinityScroll'

import Utils from 'EurestoFonction/Utils'
import {Fab} from '@material-ui/core'

moment.locale('fr')

export default class extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      messageConfiguration: [],
      messageAction: {},
      messageId: undefined,
      messagesSelected: [],
      messages: [],
      messagesLoading: true,
      messagesLength: 0,
      scrollBodyPosition: 0,
      recherche_message_messagerie: '',
      dossierKey: Utils.getRandomNumber(),
    }
    Data.addCbRestate(Constants.module.MESSAGERIE, Constants.donnee.message, (data) => {
      let messages = [...this.state.messages]
      let referenceMessages = this.state.referenceMessages && [...this.state.referenceMessages] || []
      let messagesLength = this.state.messagesLength
      let referenceId = this.state.referenceId
      let messageId = this.state.messageId
      if (data.action === Constants.broadcastAction.delete) {
        let pos = messages.findIndex(m => m.id === parseInt(data.id))
        const posRef = referenceMessages.findIndex(m => m.id === parseInt(data.id))
        if (posRef !== -1) {
          const delRef = referenceMessages.splice(posRef, 1)[0]
          pos = (pos === -1 ? messages.findIndex(m => parseInt(m.sousMessageId) === delRef.reference_id) : pos)
          if (pos !== -1) {
            if (posRef === 0) {
              messages[pos] = {
                ...messages[pos],
                ...referenceMessages[0]
              }
            }
            //messages[pos].sousMessageId = referenceMessages[0].reference_id
            messages[pos].nbRow -= 1
          }
          if (referenceMessages.length === 1) {
            referenceMessages = []
          }
        } else if (pos !== -1) {
          messagesLength -= 1
          messages.splice(pos, 1)
        }
        if(parseInt(data.id) === messageId) {
          messageId = undefined;
          this.props.selectMessageMessagerie(undefined)
        }
      } else if (data.action === Constants.broadcastAction.add) {
        const pos = messages.findIndex(m => m.id === data.id)
        if (pos === -1) {
          if (data.results[0].sousMessageId) {
            if (messages.length === 1) {
              messages[0].sousMessageId = data.results[0].sousMessageId
              messages[0].reference_id = data.results[0].sousMessageId
            }
            let posRef = messages.findIndex(m => parseInt(m.sousMessageId) === parseInt(data.results[0].sousMessageId))
            if (posRef === -1) {
              posRef = messages.findIndex(m => m.id === parseInt(data.results[0].sousMessageId))
            }
            if (posRef !== -1) {
              messagesLength -= 1
              data.results[0].nbRow = messages[posRef].nbRow + 1
              messages.splice(posRef, 1)
            }
            if (this.state.referenceId === data.results[0].sousMessageId) {
              data.results[0].reference_id = data.results[0].sousMessageId
              referenceMessages = [{
                id: data.results[0].id,
                date_envoi: data.results[0].date_envoi,
                message_id: data.results[0].message_id,
                reference_id: data.results[0].reference_id,
                sousMessageId: data.results[0].reference_id,
                messagerie_id: data.results[0].messagerie_id,
                body: data.results[0].body
              }].concat(referenceMessages)
            }
          }
          messagesLength += 1
          messages = [...data.results, ...messages]

        }
      }
      this.setState({
        messages: messages,
        messageId: messageId,
        referenceMessages: referenceMessages.length > 1 && referenceMessages || [],
        referenceId: referenceMessages.length > 1 && referenceId || undefined,
        messagesLength: messagesLength,
      })
    })
  }

  componentDidMount () {
    this.listMessageAction()
  }

  listMessageAction = async _ => {
    const result = await ApiRequest(project.api + 'messagerie', {
      requete: 'message',
      action: 'list',
      offset: this.state.messages && this.state.messages.length || 0
    }, {  showAlertError: false })
    if (result && result.results && result.results.length > 0) {
      this.setState({
        messages: this.state.messages && this.state.messages.length === 0 && result.results || (this.state.messages || []).concat(result.results),
        messagesLength: this.state.messages && this.state.messages.length === 0 && result.length || this.state.messagesLength,
        scrollBodyPosition: $('#message-action-list').scrollTop(),
        messagesLoading: false,
      }, () => {
        $('#message-action-list').scrollTop(this.state.scrollBodyPosition)
      })
    } else {
      this.setState({
        messages: [],
        messagesLength: 0,
        messagesLoading: false,
      }, this.forceUpdate)
    }
  }

  getMessageMessagerie = async (id, fromReference = false) => {
    if (this.state.messageId !== id) {
      const r = await ApiRequest(project.api + 'messagerie', {
        requete: 'message',
        action: 'get',
        id: id
      }, {  showAlertError: false })
      if (r && r.code === 1) {
        this.setState({
          messageId: id,
          referenceId: fromReference && this.state.referenceId || undefined
        }, () => this.props.selectMessageMessagerie(r.results))
      }
    } else {
      this.setState({
        messageId: undefined,
      }, () => this.props.selectMessageMessagerie())
    }

  }

  getMessageMessagerieReference = async (id) => {
    return await ApiRequest(project.api + 'messagerie', {
      requete: 'message',
      action: 'get',
      reference_id: id
    }, {  showAlertError: false })
  }

  selectMessageReference = async (id) => {
    this.setState({
      referenceId: this.state.referenceId !== id && id || undefined,
      referenceMessages: this.state.referenceId !== id && (await this.getMessageMessagerieReference(id)).results || [],
      messageId: undefined,
    })
  }

  recherche = (data, name) => {
    let messageToShow
    if (name === 'recherche_message_messagerie') {
      messageToShow = this.state.messages
    } else {
      messageToShow = this.state.messages
    }
    this.setState({
      [name]: data,
    }, () => {
      this.setState({
        messageToShow: messageToShow,
      })
    })
  }

  showMessage = (message, allSubject) => {
    return (
      <span key={message.id + '-' + Utils.getRandomNumber()}>
        {!allSubject && <div style={{
          fontSize: '18px !important',
          margin: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'pre',
          wordWrap: 'break-word',
          overflowWrap: 'break-word',
          height: 18,
          maxHeight: 18,
          maxWidth: !allSubject && message.sousMessageId && message.nbRow > 1 && 'calc( 100% - 40px )' || 'calc( 100% - 5px )',
          width: !allSubject && message.sousMessageId && message.nbRow > 1 && 'calc( 100% - 40px )' || 'calc( 100% - 5px )',
          lineHeight: '18px',
          display: 'inline',
          position: 'absolute'
        }}>{JSON.parse(message.body).subject}</div>}
        {!allSubject && message.sousMessageId && message.nbRow > 1 &&
        <div className={'EurestoSecondary EurestoPrimary--text pull pull-right'} style={{
          borderRadius: 10, height: 18, minWidth: 18, width: 'auto', maxWidth: 54, textAlign: 'center', padding: 2,
          display: 'inline-block'
        }}>{message.nbRow}</div> || ''}
        {allSubject && <strong style={{
          maxWidth: 'calc( 100% - 40px )',
          width: 'calc( 100% - 40px )', textAlign: 'left'
        }}>{JSON.parse(message.body).subject.slice(0, 50)}</strong>}
        {!((!isNaN(message.sousMessageId) && message.sousMessageId) && message.nbRow > 1) && <div>
          <br/>
          <i
            style={{ fontSize: 12 }}>De {(JSON.parse(message.body).from.value[0].name || JSON.parse(message.body).from.value[0].address) + ', ' + moment(message.date_envoi).format('DD/MM/YY HH:mm:ss')},<br/> à {JSON.parse(message.body).to && ((JSON.parse(message.body).to.value[0].name || JSON.parse(message.body).from.value[0].address) + (JSON.parse(message.body).to.value.length > 1 && '...' || ''))}
          </i>

          <br/>
          <span
            style={{ fontSize: 14, textAlign: 'left' }}
            dangerouslySetInnerHTML={{ __html: JSON.parse(message.body).corps }}></span></div>
        }
      </span>
    )
  }

  deleteMessage = async () => {
    const messagesSelected = this.state.messageId && [{ id: this.state.messageId }] || [...this.state.referenceMessages]
    await Promise.all((messagesSelected || []).map(async (message, i) => {
      return await ApiRequest(project.api + 'messagerie', {
        requete: 'message',
        action: 'delete',
        id: message.id,
      }, {
        showAlertError: (i+1) === messagesSelected.length
      })
    }))
  }

  render () {
    return (
      <EurestoDiv key={this.state.key}
                  title={<div>
                    <Fab size="small"
                            onClick={this.props.showMessageManagement}
                            className={('EurestoPrimary')}>
                      &nbsp;<i className={'ei-commun_fleche ei-left EurestoSecondary--text'}/>&nbsp;
                      <span
                        className={'EurestoText--text'}/></Fab>&nbsp;
                    {EurestoI18n.t('commun:Messages non classés') + ' (' + this.state.messages.length + '/' + this.state.messagesLength + ')'}</div>}
                  style={{
                    height: User.CalculHeight.getHeightWanted(58 + this.props.maxHeightWindow),
                    paddingTop: 1,
                    maxHeight: User.CalculHeight.getHeightWanted(58 + this.props.maxHeightWindow),
                    overflowY: 'hidden'
                  }}>
        <Grid container style={{ margin: 0, padding: 3, backgroundColor: '#F0F0F0' }} spacing={0}
              justify={'space-around'}>
          <Grid item xs={1} style={{ margin: 0, padding: 0 }}>
            <Fab size={'small'} onClick={this.deleteMessage}>
              <i className={'ei-commun_supprimer'}/>
            </Fab>
          </Grid>
          <Grid item xs={10} style={{ margin: 0, padding: 0 }}>
            <Input placeholder={'Recherche'} style={{ backgroundColor: 'white', borderRadius: 4,paddingBottom: 0 }}
                   value={this.state.recherche_message_messagerie}
                   name={'recherche_message_messagerie'}
                   onChange={this.recherche}
                   InputProps={{
                     startAdornment: (
                       <Grid container spacing={0}
                             style={{ margin: 0, padding: 2.5, width: 'auto',
                               zIndex: 3000,
                               //backgroundColor: 'lightgrey'
                               }}
                             justify={'center'}
                             alignItems={'center'}>
                         <i className={'ei-commun_rechercher'}/>
                       </Grid>
                     ),
                   }}/>
          </Grid>
        </Grid>
        <div
          id={'message-action-list'}
          style={{
            margin: 0, padding: 0,
            maxHeight: User.CalculHeight.getHeightWanted(70 + this.props.maxHeightWindow, (false && this.state.messageId && ' - 60% ' || ' - 39px ')),
            overflowY: 'auto'
          }}>
          {
            this.state.messages.map((message, i) => {
              return (
                <span style={{ textAlign: 'left' }}><Grid
                  key={'messageToShow-' + message.id + '-' + Utils.getRandomNumber()}
                  className={this.state.referenceId === (!isNaN(message.sousMessageId) && message.sousMessageId) || this.state.messageId === message.id ? 'EurestoSecondary--text EurestoPrimary' : ''}
                  item xs={12} style={{
                  margin: 0,
                  marginLeft: 1,
                  marginRight: 1,
                  textOverflow: !(this.state.referenceId === (!isNaN(message.sousMessageId) && message.sousMessageId)) && 'ellipsis',
                  whiteSpace: !(this.state.referenceId === (!isNaN(message.sousMessageId) && message.sousMessageId)) && '-moz-pre-wrap',
                  wordWrap: !(this.state.referenceId === (!isNaN(message.sousMessageId) && message.sousMessageId)) && 'break-word',
                  overflowWrap: !(this.state.referenceId === (!isNaN(message.sousMessageId) && message.sousMessageId)) && 'break-word',
                  border: '1px solid black',
                  borderTop: i > 0 && 'none' || '1px solid black',
                  maxHeight: this.state.referenceId === (!isNaN(message.sousMessageId) && message.sousMessageId) && '400px' || '75px',
                  overflow: 'hidden',
                  overflowY: this.state.referenceId === (!isNaN(message.sousMessageId) && message.sousMessageId) && 'auto' || 'hidden',
                  width: 'calc(100% - 2px)',
                  padding: 2,
                  paddingRight: 10,
                  position: 'relative',
                  textAlign: !(this.state.referenceId === (!isNaN(message.sousMessageId) && message.sousMessageId)) && 'left',
                  lineHeight: !(this.state.referenceId === (!isNaN(message.sousMessageId) && message.sousMessageId)) && '15px',
                  cursor: 'pointer'
                }}
                  onClick={() => !isNaN(message.sousMessageId) && message.nbRow > 1 && (message.sousMessageId && this.selectMessageReference(message.sousMessageId)) || this.getMessageMessagerie(message.id)}>
                    {this.showMessage(message, false)}
                  </Grid>
                  {this.state.referenceId === (!isNaN(message.sousMessageId) && message.sousMessageId) && (this.state.referenceMessages || []).map((messageRef, i) => {
                    return (
                      <Grid
                        key={'messageToShow-' + messageRef.id + '-' + Utils.getRandomNumber()}
                        className={this.state.messageId === (!isNaN(messageRef.sousMessageId) && messageRef.sousMessageId || messageRef.id) ? 'EurestoSecondary--text EurestoPrimary' : ''}
                        item xs={12} style={{
                        margin: 0,
                        marginLeft: 1,
                        marginRight: 1,
                        textOverflow: 'ellipsis',
                        whiteSpace: '-moz-pre-wrap',
                        wordWrap: 'break-word',
                        overflowWrap: 'break-word',
                        border: '1px solid black',
                        borderTop: i > 0 && 'none' || '1px solid black',
                        maxHeight: '75px',
                        height: '75px',
                        overflow: 'hidden',
                        width: 'calc(100% - 2px)',
                        padding: 2,
                        paddingRight: 10,
                        borderLeft: '4px solid black',
                        textAlign: 'left',
                        lineHeight: '15px',
                        cursor: 'pointer',
                        position: 'relative',
                      }}
                        onClick={() => this.getMessageMessagerie(messageRef.id, true)}>
                        {this.showMessage(messageRef, false)}
                      </Grid>
                    )
                  })}
                    </span>
              )
            })
          }
          <InfinityScroll over={this.state.messages.length >= this.state.messagesLength}
                          key={Utils.getRandomNumber()}
                          loading={this.state.messagesLoading}
                          element={() => $('#message-action-list')}
                          search={() => (!this.state.messagesLoading && (this.setState({ messagesLoading: true }) || this.listMessageAction()))}/>
        </div>
      </EurestoDiv>
    )
  }
}



// WEBPACK FOOTER //
// ./app/App/Module/SDD/Component/MessageMessagerie/index.js